import { onBeforeUnmount } from "vue";

import { useTabbarStoreWithOut } from "@/store/modules/Tabbar";
import { useCache } from "@/hooks/web/useCache";
import { getPendingApprovalsAll } from "@/api/leave";

const TabbarStore = useTabbarStoreWithOut();
const { wsCache } = useCache();

const onPendingApprovalsAll = () => {
  if (window.location.hash.includes('CheckingIn')) {
    getPendingApprovalsAll({ pageNum: 0, pageSize: 0, status: "0" }).then(
      (res) => {
        if (res.code == "200") {
          TabbarStore.setPendingApproval(res.data.total);
        }
      }
    );
  }
};

const onAipAll = () => {
  onPendingApprovalsAll();
};

let timeoutItem: any = null;
const onApiGlobalTimer = () => {
  const token = wsCache.get("token");
  if (token) {
    onAipAll();
    clearTimeout(timeoutItem);
    timeoutItem = setTimeout(onApiGlobalTimer, 1000 * 60 * 5);
  }
};

onBeforeUnmount(() => {
  clearTimeout(timeoutItem);
});

export default onApiGlobalTimer;
